$(document).ready(function () {
    function updateCart(type) {
        var ajax = type === undefined ? "sticky" : "ajax";
        $.ajax({
            url: `/cart?view=${ajax}`,
            success: function (response) {
                if (type !== undefined) {
                    $(".cart-page").html(response);
                } else {
                    $("#sticky-cart-content").html(response);
                    openCart();
                    updateCartQuantity();
                }
            }
        });
    }

    function updateCartQuantity() {
        $.ajax({
            url: "/cart.js",
            dataType: "json",
            cache: false,
            type: "get",
            success: function (response) {
                var count = response.item_count;
                if (count <= 0) {
                    $('.cart-link').removeClass('nav__action_link--count-active')
                } else {
                    $('.cart-link').addClass('nav__action_link--count-active')
                }
                $(".cart-items-quantity").html(count);
            }
        });
    }

    function openCart() {
        $("#cart").addClass('open');
    }

    function closeCart() {
        $("#cart").removeClass("open");
    }

    function toggleCart() {
        $("#cart").toggleClass("open");
    }

    var $body = $('body')

    $body.on("click", ".quantity-change", function () {
        var data = {
            line: $(this).data("line"),
            quantity: $(this).data("value")
        };

        $.ajax({
            url: "/cart/change.js",
            dataType: "json",
            cache: false,
            type: "post",
            data,
            success: function () {
                updateCart();
            }
        });
    });

    $body.on("change", ".quantity", function () {
        var data = {
            line: $(this).data("line"),
            quantity: $(this).val()
        };

        $.ajax({
            url: "/cart/change.js",
            dataType: "json",
            cache: false,
            type: "post",
            data,
            success: function () {
                updateCart();
            }
        });
    });

    $body.on("click", ".remove", function () {
        var data = {
            line: $(this).data("line"),
            quantity: 0
        };

        $.ajax({
            url: "/cart/change.js",
            dataType: "json",
            cache: false,
            type: "post",
            data,
            success: function () {
                updateCart();
            }
        });
    });

    $body.on("submit", ".AddToCartForm", function (e) {
        e.preventDefault();
        var $addToCartForm = $(this);

        $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: false,
            type: "post",
            data: $addToCartForm.serialize(),
            success: function () {
                updateCart();
            }
        });
    });

    $body.on("click", ".BuyAll", function (e) {
        e.preventDefault();
        var ids = $(this).data('ids').toString()

        var productIds
        if (ids.includes(',')) {
            productIds = ids.split(',');
        } else {
            productIds = [ids];
        }
        var items = []

        productIds.forEach(function (value) {
            items.push({
                id: value,
                quantity: 1
            })
        })

        let formData = { items };

        $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: false,
            type: "post",
            data: formData,
            success: function () {
                updateCart();
            }
        });
    });

    $body.on('click',  ()=> {
        closeCart();
    })

    $body.on('click', '#cart',  e => {
        e.stopPropagation();
    })
})
